<template>
<div>

  <Modal/>
      <Header/>
      <SubHeader v-if="hide" />
        <router-view/>
      <Footer />
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import SubHeader from './components/SubHeader'
import Modal from './components/Modal'

export default {
  name: 'App',
  data: () => ({
    dialog: false,
    hide: false,
  }),
  components: {
    Header,
    Footer,
    SubHeader,
    Modal
  },
  mounted() {
    this.run(this.$route)
  },
  methods: {
    run(to) {
        if(to.path == '/' || to.path == '/try-free') {
          this.hide = false;
  
        } else {
          this.hide = true;
        }
    }
  },
  watch:{
    $route (to, from){
      this.run(to);
    }
}

};
</script>

<style lang="scss">

@import "./assets/scss/theme/variables";
@import "./assets/scss/theme/mixins";
@import "./assets/scss/theme/reset";
@import "./assets/scss/theme/header";
@import "./assets/scss/theme/responsive";
@import "./assets/scss/theme/banner";
@import "./assets/scss/theme/section-intro";
@import "./assets/scss/theme/home";
@import "./assets/scss/theme/clients";
@import "./assets/scss/theme/blog";
@import "./assets/scss/theme/contact";
@import "./assets/scss/theme/btn";
@import "./assets/scss/theme/footer";


    .logo {
      padding-top:5px;
      -webkit-transition: -webkit-transform .8s ease-in-out;
              transition:         transform .8s ease-in-out;
    }
    .logo:hover {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
    }

</style>
